import React, { Component } from 'react';
import {connect} from 'react-redux';

import { Typography, Grid } from '@material-ui/core';

import TitleText from './components/TitleText';
import KontenText from './components/KontenText';
import Garis from './components/Garis';
import RenderChartSatuan from './components/RenderChartSatuan';

import Footer from './components/Footer';
import './styleDinas.css';

class DinasJatim_1 extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }

    render() { 
        return (
            <Grid 
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="stretch"
                spacing={3}
                style={{padding: '35px 25px 25px 25px'}}
                >

                {/* KONTEN KOMPOSISI */}
                <Grid item xs={6}>
                    <table>
                        <tr>
                            <td>
                                <img src="/image/dinas/komposisi.svg" className="img-title"/>
                            </td>
                            <td>
                                <TitleText title={'KOMPOSISI TEST C`AGCU'} subTitle={'DINAS PENDIDIKAN PROVINSI JAWA TIMUR'} />
                            </td>
                        </tr>
                    </table>
                    <Garis lebar={380}/>
                </Grid>

                {/* KONTEN KOMPOSISI */}
                <Grid item xs={9}>
                    <Garis/>
                </Grid>

                <Grid item xs={12} style={{margin : '-33px 0px 0px 20px'}}>
                    <Grid container>
                        <Grid item xs={3}>
                            <div className="lingkaran-kecil main-bg-color" />
                            <KontenText title={'KOGNITIF'} subTitle={'4 Mata Pelajaran'} />
                        </Grid>
                        <Grid item xs={3}>
                            <div className="lingkaran-kecil main-bg-color" />
                            <KontenText title={'LEARNING STYLE'} subTitle={'48 Butir Soal'} />
                        </Grid>
                        <Grid item xs={3}>
                            <div className="lingkaran-kecil main-bg-color" />
                            <KontenText title={'PSYCHOLOGY TEST'} subTitle={'24 Butir Soal'} />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Garis />
                </Grid>

                {/* *********************************************************************************************** */}

                {/* data pendidikan SMA negeri */}
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                    {/* Kiri */}
                        <Grid item xs={6} >
                            <Grid container>
                                <Grid item xs={12}>
                                    <table>
                                        <tr>
                                            <td>
                                                <img src="/image/dinas/data-pendidikan.svg" className="img-title"/>
                                            </td>
                                            <td>
                                                <TitleText title={'DATA PENDIDIKAN SMA NEGERI'} subTitle={'PROVINSI JAWA TIMUR'} />
                                            </td>
                                        </tr>
                                    </table>
                                    <Garis/>
                                </Grid>
                                <Grid item xs={6}>
                                    <KontenText title={'JUMLAH WILAYAH'} subTitle={'38 kabupaten/kota'} />
                                </Grid>
                                <Grid item xs={6}>
                                    <KontenText title={'SATUAN PENDIDIKAN'} subTitle={'423 Sekolah'} />
                                </Grid>
                                <Garis/>

                                <Grid item xs={6}>
                                    <KontenText title={'JUMLAH SISWA'} subTitle={'407.258 Siswa'} />
                                </Grid>
                                <Garis/>
                            </Grid>
                        </Grid>

                        {/* Kanan */}
                        <Grid item xs={6}>
                            <Grid container >
                                <Grid item xs={8}>
                                    <div>
                                        <RenderChartSatuan value={84} color={'#EBA83A'}/>
                                    </div>
                                </Grid>
                                <Grid item xs={8} style={{marginLeft: 90}}>
                                    <KontenText title={'100 % SELESAI MENGERJAKAN'} subTitle={'32 kabupaten/kota'} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Garis />
                </Grid>

                {/* INFORMASI PEMETAAN KOGNITIF */}
                <Grid item xs={12}>
                    <div className="text-background main-bg-color">informasi hasil pemetaan kognitif</div>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={4} >
                        {/* kiri */}
                        <Grid item xs={6}>
                            <Grid container spacing={2}>

                                {/* kiri atas */}
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={6}>
                                            <RenderChartSatuan value={56} color={'#50CB93'} />
                                        </Grid>
                                        <Grid item xs={6} style={{alignSelf: 'center'}}>
                                            <KontenText title={'RATA-RATA PROVINSI'} subTitle={''} />
                                        </Grid>
                                    </Grid>
                                    
                                </Grid>

                                {/* kiri bawah */}
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={6}>
                                            <RenderChartSatuan value={60} color={'#FF3F00'} />
                                        </Grid>
                                        <Grid item xs={6} style={{alignSelf: 'center'}}>
                                            <KontenText title={'SEBARAN RATA-RATA NILAI TERBANYAK'} subTitle={'*Rata-rata nilai siswa mayoritas berada pada  kisaran 55,00-60,00'} />
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>

                        {/* Kanan */}
                        <Grid item xs={6}>
                            <Grid container spacing={2}>

                                {/* kiri atas */}
                                <Grid item xs={12}>
                                    <Grid container style={{placeContent: 'center'}}>
                                        <Grid item xs={6}>
                                            <RenderChartSatuan value={26} color={'#1E3163'}/>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* kiri bawah */}
                                <Grid item xs={12}>
                                    <Grid container style={{placeContent: 'center'}}>
                                        <Grid item xs={6}>
                                            <KontenText title={'DIATAS RATA-RATA PROVINSI'} subTitle={'10 Cabdindik'} />
                                            <KontenText title={''} subTitle={'10 Kabupaten/kota'}/>
                                            <Garis />
                                            <KontenText title={'SATUAN PENDIDIKAN'} subTitle={''} />
                                            <KontenText title={'54,84 %'} subTitle={'232 Sekolah'} />
                                            <Garis />
                                            <KontenText title={'SATUAN PENDIDIKAN'} subTitle={''} />
                                            <KontenText title={'54,84 %'} subTitle={'232 Sekolah'} />
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>

                <div class="component-footer"><Footer halaman={1}/></div>
                
            </Grid>

        );
    }

}

export default DinasJatim_1;